import * as React from 'react';

import Loading from '../../Loading';
import { Contain } from '../common';

const Spinner: React.FC = () => (
  <Contain>
    <Loading />
  </Contain>
);

export default Spinner;
